export default "__VITE_ASSET__5a861491__"